export default "__VITE_ASSET__CzN0wNXT__"